<template>
  <span class="card-product__like"
        @click.prevent="favoriteEvent"
        :class="{active: active}"
        v-show="list_loaded"
  ></span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  name: 'FavoriteButton',
  methods: {
    ...mapActions('favorite', ['store']),
    favoriteEvent () {
      const id_index = this.list.findIndex(id => id === this.id)
      let payload = id_index !== -1
        ? [...this.list.slice(0, id_index), ...this.list.slice(id_index + 1)]
        : [...this.list, this.id]
      this.store({ favorites: payload })
    },
  },
  computed: {
    ...mapGetters('favorite', ['list', 'list_loaded']),
    active () {
      return this.list.findIndex(id => id === this.id) !== -1
    },
  },
}
</script>

<style scoped>

</style>
